import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	progressCompleted: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	progressCompleted: {
		id: 'issue-navigator-action-export-issues.common.progress-flag.progress-completed',
		defaultMessage: '{progress}% completed',
		description:
			'Label shown below the progress bar where {progress} is the percentage of the task that has been completed',
	},
});

export default messages;
